import { defineMessages } from 'react-intl'

export default defineMessages({
  pageTitle: {
    id: 'containers.PublicRecordingRequestPage.pageTitle',
    defaultMessage: 'Recording request',
  },
  introHi: {
    id: 'containers.PublicRecordingRequestPage.introHi',
    defaultMessage: 'Hi there,',
  },
  introPrompt: {
    id: 'containers.PublicRecordingRequestPage.introPrompt',
    defaultMessage: 'We would like you to pronounce the word(s) listed below.',
  },
  introStart: {
    id: 'containers.PublicRecordingRequestPage.introStart',
    defaultMessage: 'Simply click {recordButton} located to the right of a word, to start recording.',
  },
  introInstructions: {
    id: 'containers.PublicRecordingRequestPage.introInstructions',
    defaultMessage: 'When finished, click {stopIcon} to stop your recording. Click {playIcon} to play it, or {reRecordIcon} to re-record.',
  },
  introNotification: {
    id: 'containers.PublicRecordingRequestPage.introNotification',
    defaultMessage: 'Once all words have been recorded, we will receive a notification automatically.',
  },
  allDone: {
    id: 'containers.PublicRecordingRequestPage.allDone',
    defaultMessage: 'All recordings submitted — thank you!',
  },
  pendingHeading: {
    id: 'containers.PublicRecordingRequestPage.pendingHeading',
    defaultMessage: 'Pending',
  },
  completedHeading: {
    id: 'containers.PublicRecordingRequestPage.completedHeading',
    defaultMessage: 'Completed',
  },
  notFound: {
    id: 'containers.PublicRecordingRequestPage.notFound',
    defaultMessage: 'Not found',
  },
  recorded: {
    id: 'containers.PublicRecordingRequestPage.recorded',
    defaultMessage: 'Recorded',
  },
  download: {
    id: 'containers.PublicRecordingRequestPage.download',
    defaultMessage: 'Download',
  },
  progressChip: {
    id: 'containers.PublicRecordingRequestPage.progressChip',
    defaultMessage: '{completed} of {total} recorded',
  },
  cantRecord: {
    id: 'containers.PublicRecordingRequestPage.cantRecord',
    defaultMessage: "Can't record? Upload instead",
  },
  hideUpload: {
    id: 'containers.PublicRecordingRequestPage.hideUpload',
    defaultMessage: 'Hide upload options',
  },
  uploadDescription: {
    id: 'containers.PublicRecordingRequestPage.uploadDescription',
    defaultMessage: 'Please upload an audio file containing only the specific word or phrase — no additional speech or background noise.',
  },
})
